import { ContactsApp } from '@wix/ambassador-contacts-app/http';
import { BaseApiService } from './Base.api';
import { AxiosHttpClient } from '../utils/http-client';
import {
  AdvancedFilterDTO,
  ConditionDTO,
} from '../../../domain/AdvancedFilter';

class ContactsApi extends BaseApiService {
  private readonly contactsApi = ContactsApp(this.baseUrl, {
    useRedAxios: true,
  }).ContactsServiceV4();

  private readonly httpClient = new AxiosHttpClient(this.instance);

  public deleteContact(contactId: string) {
    return this.AuthenticatedService.deleteContact({
      contactId,
    });
  }

  public bulkDeleteContacts(
    contactIds: string[] = [],
    excludedContactIds: string[] = [],
    contactAdvancedFilter: AdvancedFilterDTO = { conditions: [] },
  ) {
    return this.httpClient.post(
      `/contacts-server/api/v1/metasite/${this.msid}/deleteContactsWithFilter`,
      {
        filter: {
          contactAdvancedFilter,
          contactIds,
          excludedContactIds,
        },
      },
    );
  }

  private get AuthenticatedService() {
    return this.contactsApi({
      Authorization: this.instance,
    });
  }
}

export const contactsApi = new ContactsApi('/_api/contacts');
